import React from "react";
import { Input } from "../ui/input";

export interface InputProps
	extends React.InputHTMLAttributes<HTMLInputElement> {
	selected?: boolean;
	typing?: boolean;
}
export const SearchBox = React.forwardRef<HTMLInputElement, InputProps>(
	({ className, type, children, selected, typing, value, ...props }, ref) => {
		return (
			<div className="relative w-full">
				<Input
					className={className}
					type={type}
					ref={ref}
					value={value}
					{...props}
				/>
				{typing &&
					value &&
					!selected &&
					value?.toString().trim().length > 0 && (
						<div className="left-0 z-10 absolute bg-background p-4 border border-border rounded-xl w-full font-semibold translate-y-0.5">
							{children}
						</div>
					)}
			</div>
		);
	},
);
